/* eslint-disable */

import { ParamsData } from '../app.js';
import { Trapme, Listbox } from '../modules/trap'

export default () => {
    const header = document.getElementById("header");
    const nav = document.getElementById("nav");
    const form = header.querySelector('form');
    const has_children = document.querySelectorAll(".has-children");
    const level1s = nav.querySelectorAll(".level1");

    // justify level1 if larger than nav
    level1s.forEach(level1 => {
        if (level1.offsetLeft + level1.clientWidth > nav.clientWidth) {
            level1.classList.add("right");
        }
    })

    // gestion focus de la nav
    has_children.forEach(el => {
        let link = el.querySelector('.link0');
        el.onmouseenter = () => link.setAttribute("aria-expanded", true)

        el.onmouseleave = () => link.setAttribute("aria-expanded", false)
    })

    const closeAllLevel1 = () => {
        has_children.forEach(el => {
            el.querySelector(".link0").setAttribute("aria-expanded", false);
            el.classList.remove("hover");
            el.querySelectorAll(".link1").forEach(link => link.setAttribute("tabindex", -1))
        })
    }

    header.addEventListener("keyup", e => {
        if (!nav.contains(e.target)) closeAllLevel1();
    })

    /*
        nav.addEventListener("keyup", e => {
            if (e.target.classList.contains("link0") && e.target.classList.contains("desktop")) {
                closeAllLevel1();
                e.target.parentNode.classList.add("hover");
                e.target.setAttribute("aria-expanded", true);
                e.target.parentNode.querySelectorAll(".link1").forEach(link => link.setAttribute("tabindex", 0))
            }
        })
    */

    nav.querySelectorAll(".link0.desktop").forEach(link => {
        link.onfocus = () => {
            closeAllLevel1();
            link.parentNode.classList.add("hover");
            link.setAttribute("aria-expanded", true);
            link.parentNode.querySelectorAll(".link1").forEach(link => link.setAttribute("tabindex", 0))
        }
    });
    // accordion mobile
    const btn_level1 = document.querySelectorAll(".btn-level1");
    btn_level1.forEach(btn => {
        btn.onclick = () => {
            const hasChildren = btn.closest(".has-children");
            if (hasChildren.classList.contains("hover")) {
                closeAllLevel1();
                btn.setAttribute("aria-expanded", false);
                hasChildren.classList.remove("hover");
            } else {
                closeAllLevel1();
                btn.setAttribute("aria-expanded", true);
                hasChildren.classList.add("hover");
                hasChildren.querySelectorAll(".link1").forEach(a => a.setAttribute("tabindex", 0))
            }
        }
    })


    function autocomplete() {
        const search = header.querySelector('.search');
        const search_result = header.querySelector('.search-result');
        const search_list = header.querySelector('#search-list');
        const input = search.querySelector("input");
        const submit = search.querySelector(".submit");
        const placeholder = search.querySelector("label");
        const root = document.documentElement || window;
        const clicktouch = ('ontouchstart' in root) ? 'touchstart' : 'click';
        const clickoutside = e => !form.contains(e.target) && close();
        const url = ParamsData.wp_ajax_url;
        let isMobile = window.innerWidth < 1220;
        let wait = false;
        let isopen = false;
        let timeout = null;

        const trap = new Listbox(form);

        form.onsubmit = e => {
            e.preventDefault();
            window.location = `/?s=${input.value}`;
        }

        const ajax = onloaded => {
            wait = true;
            const formData = new FormData(form);
            formData.append('nonce', form.dataset.nonce);
            formData.append('action', form.getAttribute('action'));

            const xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.onload = () => {
                const response = JSON.parse(xhr.response);
                onloaded(response.html);
                wait = false;
            };
            xhr.send(formData);
        };

        const focusout = e => {
            if (e.key === "Tab") {
                !form.contains(document.activeElement) && close();
            }
        }



        trap.close = () => {
            close();
        }

        const open = () => {
            if (isMobile) return;
            if (wait) return;

            window.addEventListener(clicktouch, clickoutside);
            document.addEventListener("keyup", focusout, { passive: false });
            isopen = true;

            ajax(html => {
                input.setAttribute("aria-expanded", true);
                if (html == "") {
                    close();
                } else {
                    search_list.innerHTML = html;
                    search_result.style.height = `${search_list.offsetHeight}px`;
                    search_result.addEventListener("transitionend", () => {
                        search_result.style.height = "auto";
                    }, { once: true });
                    trap.start(search_result.querySelectorAll("li"));
                }

            });
        }

        const close = () => {
            trap.stop();
            window.removeEventListener(clicktouch, clickoutside);
            document.removeEventListener("keyup", focusout);
            input.setAttribute("aria-expanded", false);

            if (input.value.length <= 0) {
                if (!document.activeElement) placeholder.classList.remove("hide");
            }
            if (!isMobile && search_list) {
                search_result.style.height = `${search_list.offsetHeight}px`;
                setTimeout(() => {
                    search_result.style.height = 0;
                }, 2);
                search_result.addEventListener("transitionend", () => {
                    search_result.style.height = 0;
                }, { once: true });
            }

            isopen = false;
        }

        input.addEventListener("focus", () => {
            if (isopen) return;
            input.value.length >= 2 && open();
            placeholder.classList.add("hide")
        });

        input.addEventListener("blur", () => {
            input.value.length == 0 && placeholder.classList.remove('hide');
        });

        input.oninput = () => {
            timeout && clearTimeout(timeout);
            timeout = setTimeout(() => (input.value.length >= 2 ? open() : close()), 200);
            placeholder.classList.add('hide');
        }
    }

    function mobile() {
        const fieldset = header.querySelector('.fieldset');
        const btn_back = header.querySelector('.btn-back');
        const btn_nav = header.querySelector('.btn-nav');
        const btn_search = header.querySelector('.btn-search');
        const trapNav = new Trapme(header, header.querySelectorAll(".btn-nav,#nav a"));
        const trapSearch = new Trapme(header, header.querySelectorAll('.btn-back, input'));

        const closeNav = () => {
            btn_nav.classList.remove("active");
            nav.style.setProperty("--translate", `0`);
            btn_nav.setAttribute("aria-expanded", false);
            nav.addEventListener("transitionend", () => nav.classList.remove("open"), { once: true });
            trapNav.stop();
        }

        trapNav.close = () => {
            closeNav();
            btn_nav.focus();
        }

        btn_nav.onclick = () => {
            if (btn_nav.classList.contains("active")) {
                closeNav();
            } else {
                btn_nav.classList.add("active");
                nav.classList.add("open");
                nav.style.setProperty("--translate", `100%`);
                btn_nav.setAttribute("aria-expanded", true);
                trapNav.start();
            }
        }

        const openSearch = () => {
            btn_search.setAttribute("aria-expanded", true);
            form.classList.add("open");
            form.style.setProperty("--height", `${fieldset.offsetHeight}px`);
            form.addEventListener("transitionend", () => {
                form.style.setProperty("--height", `auto`);
                trapSearch.start();
                trapSearch.close = () => closeSearch();
            }, { once: true });

        }

        const closeSearch = () => {
            btn_search.setAttribute("aria-expanded", false);
            form.style.setProperty("--height", `${fieldset.offsetHeight}px`);
            setTimeout(() => form.style.setProperty("--height", 0), 1);
            form.addEventListener("transitionend", () => form.classList.remove("open"), { once: true });
            trapSearch.start();
            btn_search.focus();
        }

        btn_search.onclick = () => form.classList.contains("open") ? closeSearch() : openSearch();
        btn_back.onclick = () => closeSearch();
    }

    autocomplete();

    mobile();
};

